var render = function render(_c,_vm){return _c('mm-alert',{key:"needPay",staticClass:"order-detail-tips",attrs:{"type":"error","closable":false}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('order.pending'),expression:"'order.pending'"}]}),_vm._v("："+_vm._s(_vm.props.currency)+_vm._s(_vm.props.amount)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }